import React from "react";

const LogManagement = ()=>{
    return
}

export default LogManagement;